import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import { getLocales } from 'assets/locales/Locale';
import { Fragment, useState } from 'react';
import { PricingFilters, usePriceEditor } from '../hooks/usePriceEditor';
import { usePriceSelectionTools } from '../hooks/usePriceSelectionTools';
import PriceAdjustmentEditPricingPlan from './PriceAdjustmentEditPricingPlan';
import { keys } from 'lodash';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import { inputStyles } from 'assets/components/inputs/Input';
import ProductType from 'models/enums/ProductType';
import { cleanValues } from 'assets/utils/data/Object';
import PriceAdjustmentEditProductCustomPricePoint from './PriceAdjustmentEditProductCustomPricePoint';

export default function PriceAdjustmentAddFilter() {
  const { translate, lang } = getLocales();
  const {
    filters,
    dataMappings,
    addEmptyPrices,
    setOverrideEmptyPrices,
    overrideEmptyPrice,
    pricingType,
    permissions,
  } = usePriceEditor();
  const { dataTypeId, dataType } = usePriceSelectionTools();
  const [newFilters, setNewFilters] = useState<PricingFilters>({});
  function updatePartial(props: PricingFilters) {
    setNewFilters((old) => ({ ...old, ...props }));
  }
  function handleApply() {
    addEmptyPrices(cleanValues(newFilters, { delete: null, nullify: '' }));
    setNewFilters({});
  }

  const [editedId, setEditedId] = useState<number | null>(null);

  if (permissions.specificUserType) {
    return null;
  }
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
      {editedId !== null && pricingType == ProductType.warrantiClassBased && (
        <PriceAdjustmentEditPricingPlan
          pricingPlanId={editedId}
          productId={dataTypeId}
          onCancel={() => setEditedId(null)}
        />
      )}
      {editedId !== null && pricingType == ProductType.custom && (
        <PriceAdjustmentEditProductCustomPricePoint
          productCustomPricePointId={editedId}
          productId={dataTypeId}
          onCancel={() => setEditedId(null)}
        />
      )}
      {pricingType !== ProductType.warrantiClassBased && (
        <CheckInput
          name="overrideEmptyPrice"
          label={lang.overrideEmptyPrices}
          value={overrideEmptyPrice}
          onChange={({ overrideEmptyPrice }) => setOverrideEmptyPrices(!!overrideEmptyPrice)}
          class={inputStyles.check.checkbox}
          style={{ width: '200px', marginRight: 'auto' }}
        />
      )}
      <InputWrapper>
        <DataMap
          data={filters}
          render={({ data: filter }) => {
            const mappedData: Component.Input.Select.SelectionItem[] = dataMappings[filter.key]?.map((it) => ({
              id: it.value,
              title: translate(it.label),
              subtitle: filter.options.some((o) => o.value === it.value) ? lang.alreadyAdded : undefined,
            }));
            const isEditable = filter.key === 'productPricingPlan' || filter.key === 'productCustomPricePoint';
            return (
              <Fragment key={filter.key}>
                {filter.type === 'object' && (!!mappedData?.length || (!mappedData?.length && isEditable)) && (
                  <SelectInput
                    name={filter.key}
                    onChange={updatePartial as any}
                    value={newFilters[filter.key] as any}
                    label={translate(filter.key)}
                    data={mappedData}
                    onAdd={isEditable && dataType === 'product' ? () => setEditedId(0) : undefined}
                    onEdit={isEditable && dataType === 'product' ? setEditedId : undefined}
                  />
                )}
                {filter.type === 'number' && (
                  <NumberInput
                    name={filter.key}
                    onChange={updatePartial as any}
                    value={newFilters[filter.key] as any}
                    label={translate(filter.key)}
                  />
                )}
                {filter.type === 'string' && (
                  <TextInput
                    name={filter.key}
                    onChange={updatePartial as any}
                    value={newFilters[filter.key] as any}
                    label={translate(filter.key)}
                  />
                )}
              </Fragment>
            );
          }}
        />
        <Button
          media="fas-level-down-alt"
          class={ThemeButtonCircle}
          onClick={handleApply}
          active={!!keys(newFilters).length}
          disabled={!keys(newFilters).length}
          htmlElementProps={{ title: lang.apply }}
        />
      </InputWrapper>
    </div>
  );
}
